// import $ from 'jquery'
import 'slick-carousel'
import { bp } from '../../../assets/src/scripts/core.js'

export class HeaderCards {
  constructor ($container) {
    this.$container = $container
    this.$list = $container.find('.header-cards-list')

    if (!this.$list.length || this.$list.children().length < 2) {
      return
    }

    this.updateActiveBounds = this.updateActiveBounds.bind(this)
    this.onScrollOrResize = this.onScrollOrResize.bind(this)
    this.checkScrollPosition = this.checkScrollPosition.bind(this)
    this.scrollRaf = null

    this.$list.on('init breakpoint afterChange setPosition', this.updateActiveBounds)

    this.$list.slick({
      mobileFirst: true,
      infinite: false,
      arrows: true,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '2rem',
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: bp.md,
          settings: {
            arrows: true,
            dots: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: '0',
          }
        },
        {
          breakpoint: bp.lg,
          settings: 'unslick'
        }
      ]
    })

    window.addEventListener('scroll', this.onScrollOrResize, { passive: true })
    window.addEventListener('resize', this.onScrollOrResize, { passive: true })

    this.checkScrollPosition()
  }

  updateActiveBounds () {
    const $active = this.$list.find('.slick-slide.slick-active')
    this.$list.find('.is-first-visible, .is-last-visible').removeClass('is-first-visible is-last-visible')

    if (!$active.length) {
      return
    }

    $active.first().addClass('is-first-visible')
    $active.last().addClass('is-last-visible')
  }

  onScrollOrResize () {
    if (this.scrollRaf) {
      window.cancelAnimationFrame(this.scrollRaf)
    }
    this.scrollRaf = window.requestAnimationFrame(this.checkScrollPosition)
  }

  checkScrollPosition () {
    const $items = this.$list.find('.header-cards-item')

    if (window.innerWidth < bp.lg) {
      $items.removeClass('no-margin')
      return
    }

    const listEl = this.$list.get(0)
    if (!listEl) {
      return
    }

    const headerEl = document.querySelector('header')
    const headerHeight = headerEl ? headerEl.offsetHeight : 0

    if (window.scrollY > headerHeight) {
      $items.addClass('no-margin')
    } else {
      $items.removeClass('no-margin')
    }
  }
}
